import React from 'react';
import { Grid } from '@material-ui/core';
import PropTypes from 'prop-types';
import SelectWithValidation from '../../../../../components/ValidationFormElements/SelectWithValidation';

const ModelInput = ({ formValues, errors, clearError, modelNames }) => (
  <Grid item xs={12} sm={6}>
    <SelectWithValidation
      required
      disabled
      name="modelName"
      label="transportation.modelName"
      value={formValues.modelName}
      formProps={{
        errors,
        clearError,
      }}
      getMenuLabel={(option) => option.label}
      options={modelNames}
      onChange={() => {}}
    />
  </Grid>
);

ModelInput.propTypes = {
  errors: PropTypes.shape({}).isRequired,
  clearError: PropTypes.func.isRequired,
  formValues: PropTypes.shape({
    modelName: PropTypes.shape({}),
  }).isRequired,
  modelNames: PropTypes.arrayOf(PropTypes.shape({})).isRequired,
};

export default ModelInput;
